<template>
    <div class="definition-result-container" :id="'result-' + index">
      <div class="row results-row">
        <div class="col-sm-5">
          <div
                  class="text"
                  v-html="this.highlightedWord">
          </div>
        </div>
        <div class="col-sm-7">
          <div class="right-side">
            <div
                    v-if="this.result.definition != '' && this.result.definition != null"
                    class="text"
            >
              <div v-if="!editing" @click.shift="handleClick">
                <span v-html="this.highlightedText"></span>
              </div>
              <div v-if="editing" >
                <textarea  ref="textarea" v-bind:class="{ largerfont: largerFont }" class="editing-text-area" v-model="editingText"></textarea>
                <button @click="handleSaveEdit" class="button" style="margin-top: 5px;">Save</button>
                <button @click="handleCancelEdit" class="button" style="margin-top: 5px;">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import {mapMutations, mapState} from 'vuex'
import Vue from "vue";
import Utils, {processTibetan} from '../utils'

export default {
  name: 'Definition',
  props: {
    result: Object,
    index: Number
  },
  data() {
    return {
      showScore: false,
      editing: false,
      largerfont: false,
      editingText: this.result.definition,
      text: this.result.definition
    }
  },
  components: {},
  methods: {
    copyToClipboard() {

    },
    ...mapMutations([
      'setEditInProcess',
    ]),
    handleClick() {
      if (this.allowEdits) {
        if (this.editInProcess) {
          alert("Finish open edit first")
          return
        }
        this.editing = true;
        this.setEditInProcess(true);
        Vue.nextTick(() => {
          this.resizeTextArea();
        });
      }
    },
    async handleSaveEdit() {
      this.text = this.editingText;
      await this.saveEdit();
      this.setEditInProcess(false);
    },
    handleCancelEdit() {
      this.editing = false;
      this.setEditInProcess(false);
    },
    async saveEdit() {

      let service = null;

      if (this.searchType === 'monlam-tibetanToEnglish') {
        service = this.$server.monlamEnglishToTibetanService
      } else if (this.searchType === 'monlam-englishToTibetan') {
        service = this.$server.monlamEnglishToTibetanService
      } else if (this.searchType === 'monlam-tibetanToTibetan') {
        service = this.$server.monlamTibetanToTibetanService
      } else {
        return;
      }

      const columnName = "definition";

      // eslint-disable-next-line no-console
      this.$log.debug(service)
      this.$log.debug(`Editing id=${this.result._id}, searchType= ${this.searchType} column = ${columnName} new value = "${this.text}"`)

      const newValue = this.text
      await service.patch(this.result._id, {
        value: newValue,
        columnName: this.columnName, // current ignored
        comment: "",
        user: "",
        entryId: this.entryId,
        token: this.editToken
      });
      this.editing = false;
    },
    resizeTextArea() {
      const {textarea} = this.$refs;
      textarea.style.height = textarea.scrollHeight + 10 + 'px';
    },
  },
  computed: {
    ...mapState('app', [
      'searchText',
      'searchType',
      'allowEdits',
      'editInProcess',
      'editToken'
    ]),
    highlightedText() {

      this.$log.debug("PRE-PROCESSING TEXT: ", this.text)

      let processed = this.text;

      if (this.searchType === "monlam-tibetanToTibetan") {

        // parse numbers "1.", "2.", "3.", etc.
        processed = this.text.replace(/([0-9]+)./gm, (match, s1) => {
          if (s1 === "1.") return `<span class="circle">${s1}</span>`
          else return `<br/><span class="circle">${s1}</span>`
        })

        processed = processed.replace(/\r\n|\r|\n/gm, "<br/>")

        // monlam seems to use tibetan numbers butted up at front of phrases
        // to mark them for styling
        processed = processed.replace(/[༡-༩]([^\s]*[།ག])/gm, (match, s1) => {
          return ` <span style="color:#6767ce">${s1}</span>`
        })

        processed = processed.replace(/(\s)([༠-༩]{1,2})(\s)/gm, (match, s1, s2, s3) => {
          return `${s1}<span style="color:#6767ce; font-weight:bold">${s2}</span>${s3}`
        })

        processed = processed.replace(/རྒྱུན་སྤྱོད།|དཔེར་ན།/gm, (match) => {
          return `<span style='color: darkgray; font-weight: bold'>${match}</span>`
        });

      }

      processed = Utils.processTibetan(processed, "font-size: 2.0em; margin-bottom: 10px;")

      this.$log.debug("POST-PROCESSING TEXT: ", processed)

      return Utils.highlight(processed, this.searchText, "highlight", this.searchType)
    },
    highlightedWord() {
      let processed = Utils.processTibetan(this.result.word, "font-size: 2.0em; margin-bottom: 10px;")
      return Utils.highlight(processed, this.searchText, "highlight", this.searchType);
    }
  }
}
</script>

<style scoped>

  .results-row {
    text-align:left;
    margin: 20px;
    padding: 20px;
    margin-bottom: 0px;
    margin-top:0px
  }

  .text {
    margin-bottom: 15px;
  }

  .tibetan-text {
    font-size: 2.0em;
    margin-bottom: 10px;
  }

  .editing-text-area {
    width: 100%;
  }

  .button {
    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
  }

  button:hover {
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 3px 9px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
  }

  div.right-side >>> .circle {
    border-radius: 50%;
    padding: 5px 10px;
    margin-right: 5px;
    background: none;
    border: 1px solid #000;
    color: #000;
    text-align: center;
    font: 20px Arial, sans-serif;
  }

</style>
